import React from 'react';
import './MdxTitle.scss';

const MdxTitle = (props: any) => {
  // eslint-disable-next-line react/destructuring-assignment
  return <div className="mdx-title">{props.children}</div>;
};

export default MdxTitle;
